import type { FaireProductEntity } from "../../entity_types/product";

export const p_g6rfwhzv58: FaireProductEntity = {
  token: "p_g6rfwhzv58",
  type: "product",
  name: "No. 5 Botaniste Chroma Candle",
  brandToken: "b_x9wh59mbc7",
  brandName: "Cachet",
  imageUrl:
    "https://cdn.faire.com/fastly/70ead6477a219e0d6574637239f1bea03d4bcf5c8a6222dca2fd67f904339d4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b40cd690b348c4e484234e4080b6b9b115ac454f5aa6b962aefa6ac529c543a3.jpeg",
    "https://cdn.faire.com/fastly/d76649febbcf8f3ac7a3d0b3c47d4057e6166d42089920bf985d6aed364800c7.jpeg",
    "https://cdn.faire.com/fastly/fc95c283b5fb9e78a301f7bbcff28ce203464475e69e59aaa255bda88718cff7.jpeg",
  ],
  priceDollars: 15,
  description:
    "Notes: Santal, Cucumber, Vetiver, Iris\n\nFresh yet grounded, delicate, and intentional, this scent evokes time spent meticulously caring after plants, slowing down, and observing nature grow, big or small.\n\nThese candles are perfect for a little treat! They are nestled in a beautiful and colorful ceramic vessel which can be reused and cherished as a household item.\n\nHandpoured soy wax candle - 5oz / 145g",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:06.422Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
